import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import {
    setSessionJSONItem,
    getSessionJSONItem,
    clearSessionJSONItem
} from '@salesforce/retail-react-app/app/utils/utils'

const useClaraPreferences = () => {
    const isClient = typeof window !== 'undefined'
    const cached = isClient ? getSessionJSONItem('claraConfig') : null

    const {data, isLoading, error, refetch} = useCustomQuery(
        {
            options: {
                method: 'GET',
                customApiPathParameters: {
                    apiVersion: 'v1',
                    endpointPath: '/preferences?c_ids=claraConfig',
                    apiName: 'preferences'
                }
            },
            rawResponse: false
        },
        {
            enabled: !cached && isClient
        }
    )

    // Parse claraConfig from API response and cache it
    let claraConfig = cached
    if (data && !cached && isClient) {
        try {
            const parsed = JSON.parse(data.claraConfig || '{}')
            claraConfig = parsed
            setSessionJSONItem('claraConfig', parsed)
        } catch (error) {
            console.warn('Error parsing claraConfig from API:', error)
            clearSessionJSONItem('claraConfig')
            claraConfig = {}
        }
    }

    return {
        claraConfig: claraConfig || {},
        isLoading: cached ? false : isLoading,
        error,
        refetch
    }
}

export {useClaraPreferences}
